import { Component } from "react"


/*
    Component RoundStat — ONE LINE OF THE ROUND CARD

    icon      the svg of the line
    title     what the line is called
    tone      the color of the icon plate — green, red, blue, violet, amber
    children  the value itself, anything at all
*/
class RoundStat extends Component {

    render = () => {

        /* Fields */
        const { icon, title, tone, children } = this.props

        return (
            <div className="rnd--stat">

                <div className={`rnd--stat-icon ${tone ? tone : ""}`}>{icon}</div>

                <div className="rnd--stat-box">
                    <div className="rnd--stat-title">{title}</div>
                    <div className="rnd--stat-value">{children}</div>
                </div>

            </div>
        )
    }

}

export default RoundStat
